export default {
  rateCalculator: {
    table: {
      // PrimaryKeyID:"主键id",
      CustomerName: '客户名称',
      profitmargin: '利润率（%）',
      ShippingAddress: '发货地址',
      Deliveryaddress: '送货地址',
      totalcost: '总成本',
      Totalquotation: '总报价',
      CustomerTotalPrice: '客户总价',
      TotalDifference: '总差额',
      PercentageDifference: '差额百分比',
      CalculateTheTotal: '对应的buffer算总报价',
      TotalNumberOfArticles: '总条数',
      NumberOfCompletedItems: '已完成的条数',
      pleaseNumber: '请输入数字',
      PleaseUpload: '请上传',
      Fileupload: '文件上传',
      MultipleChoice: '可多选',
      Selectfile: '选取文件',
    },
    tables: {
      NO: '编号',
      fileMode: '运费计算器模板.xls',
      OrederNumber: 'Oreder编号',
      deliveryAddress: '收货地址',
      Suburb: '国家',
      State: '州',
      Postcode: '邮编',
      Country: '城市',
      SKUs: 'SKU',
      TotalWeight: '总重量',
      Length: '长度（L）cm',
      width: '宽度（W）cm',
      Weight: '总重量（kg)',
      Height: '高度（H）cm',
      Qty: '数量（Q）',
      Volume: '体积（长x宽x高x数量）',
      PiceFromCustomer: '客户原价',

      inquiryList: '查询列表',
      totalCost: '总成本',
      totalQuote: '总报价',
      profitMargin: '利润率(%)',
      totalCustomPrice: '总定制价格',
      totalDiff: '总差异',
      totalPercentage: '合计百分比',

      bestPrice: '最佳价格',
      customerPrice: '客户价格',
      provider: '供应商',
      differPrice: '不同价格',
      diffPercentage: '差异百分比',
      exclGST: '(不含税)',
    },
    TransitDetails: '运输详情',
    ConsignmentDetails: '托运详情',
    DownloadPreview:"下载预览",
    chargeonyour:"charge on your invoice",
    LogisticsService: '物流服务费率',
  },
  SendEmail: {
    notice: {
      title: '重要通知',
      acknowledgement: '我已阅读并理解本通知及附件内容。',
    },
    table: {
      EmailTitle: '邮件标题',
      SendingTime: '发送时间',
      SendEmail: '邮箱类型',
      EmailContent: '邮件内容',
      RequireConfirmation: '需要客户确认',
      Multiples: '多附件',
      EmailType: '邮箱类型',
      Generalemail: '通用邮箱',
      BillingEmail: '账单邮箱',
      CustomerServiceEmail: '客服邮箱',
      NumberOfsuccessful:"发送成功的数量",
      NameCustomer:"发送失败的客户"
    },
  },
  LogisticsRulesTable: {
    header: {
      No: '序号',
      Logistics: '物流公司',
      Code: '物流服务',
      FuelLevy: '燃油附加费率',
      OversizedSurcharge: '超长附加费',
      OverweightSurcharge: '超重附加费',
      OtherSpecialRules: '其他特殊规则',
      UpdateDate: '更新日期'
    },
    OversizedSurchargeCol: {
      auS: '不允许超出105cm',
      auE: '不允许超出105cm',
      auI: '不允许超出105cm',
      alE: '',
      coP: '105cm以上，每个包裹收15刀，不允许超出180cm',
      diF: '每个包裹,140-200cm收8刀，200-300收18刀',
      faA: '不允许超出200cm',
      huE: '120-150cm每个包裹收3刀，150-250cm每个包裹收10刀',
    },
    OverweightSurchargeCol: {
      auS: '单包裹不允许超出22kg实重或62.5体积重',
      auE: '单包裹不允许超出22kg实重或62.5体积重',
      auI: '单包裹不允许超出20kg实重或62.5体积重',
      alE: '',
      coP: '单包裹不允许超出25kg实重，或40kg体积重',
      diF: '每有一个包裹大于30kg，则增加7刀,最多收35刀',
      faA: '单包裹不允许超出25kg实重，或40kg体积重',
      huE: '所有包裹平均重量35-75kg收10刀，75-100kg收15刀，100kg以上收105刀',
    },
    OtherSpecialRulesCol: {
      auI: '国际快递，只允许一单一个包裹',
      huE: 'WA地区燃油费率28%',
    }
  }
};
